<template>
  <div class="container-fluid">
    <section class="row">
      <div>
        <div class="mt-3 text-center">
          <img src="../../assets/join_car.png" class="w-50"/>
        </div>
        <p class="text-center fs-title fw-bold mb-0">환영합니다! :)</p>
        <p class="text-center fs-2 fw-bold">회원 정보가 저장되었습니다.</p>
        <p class="text-center fs-2 fw-bold">안내 직원을 따라가주세요.</p>
        <p class="text-center fs-5 fw-bold">
          담당 직원이 연락드릴 예정입니다
        </p>
        <p class="text-center fs-5 fw-bold">
          아래의 서류들을 미리 제출하시면<br/>
          좀 더 빠른 어플 사용이 가능합니다.
        </p>
      </div>
    </section>
    <footer class="footer d-flex flex-column mt-3 d-flex gap-1">
      <div class="d-flex flex-column gap-1" v-if="isShow">
        <button class="btn btn-primary col-12 rounded-pill" @click="moveAttach">서류 제출하기</button>
        <button class="btn btn-outline-primary col-12 rounded-pill" @click="moveAfter">다음에 하기</button>
      </div>
      <div class="d-flex" v-else>
        <button class="btn btn-outline-primary col-12 rounded-pill" @click="moveAfter">완료</button>
      </div>
    </footer>

  </div>
</template>

<script>

/**
 * 간편회원가입 - 가입 완료페이지
 */
export default {
  name: "MemberSimpleV2",
  data() {
    return {
      iv: this.$CryptoJS.enc.Hex.parse('0000000000000000'),
      key: this.$CryptoJS.enc.Utf8.parse('alkdjalsdjivlake'),
      isShow: true,
    }
  },
  mounted() {
    const pages = this.$store.getters.getPages;
    if (pages && ( pages.includes("UNKNOWN_MEMBER") || pages.includes("PAPER"))) {
      this.isShow = true;
    } else {
      this.isShow = false;
    }
  },
  methods: {
    moveAfter() {

      let isMancharo = this.$store.getters.getJoinUrl;

      let url = "https://www.2424-2424.com";
      if (isMancharo === 'mancharo') {
        url = "https://mancharo.com/";
      }
      // this.sendAttachLink()
      window.location.href = url;
    },
    moveAttach() {
      this.$emit('current-page', { page: 'member-paper' });
    },
    isEmpty(value) {
      return value === undefined || value === null || String(value).trim() === '';
    },
  },
}
</script>

<style scoped>

</style>